import { File } from './../../models/files/files.model';

export class Contentbox {
    id?: string;
    [content: string]: any;
    file?: File;

    constructor(options: any) {
        this.id = options.id;
        this.file = options.file;
    }
}
